module.exports = __webpack_public_path__ + "img/1.de8c12f6.jpg";